import { useState, useEffect } from 'react';

import http from 'services/http';

import styles from '../styles.module.css';
import { alerta } from '../../../../components/Alert';

// Aba "Milhar Brinde" das Configurações. Os campos ficavam na aba Dados; aqui
// têm carregamento e Salvar próprios, mandando só as chaves da milhar brinde
// (o backend faz merge parcial no blob de opções da banca).
const TIPOS = [
    { valor: 'nao', rotulo: 'Não' },
    { valor: 'fixo', rotulo: 'Valor fixo' },
    { valor: 'multiplicado', rotulo: 'Valor multiplicado' },
];

function CampoNumero({ rotulo, valor, aoMudar }) {
    return (
        <div className={styles.formGroup}>
            <div className={styles.label}>
                <label>{rotulo}</label>
            </div>
            <div className={styles.input}>
                <input
                    type="number"
                    inputMode="numeric"
                    className="form-control"
                    style={{ width: 200 }}
                    value={valor}
                    onChange={(e) => aoMudar(e.target.value)}
                />
            </div>
        </div>
    );
}

export default function ConfiguracaoMilharBrinde() {
    const [tipo, setTipo] = useState('nao');
    const [minimo, setMinimo] = useState('');
    const [maximo, setMaximo] = useState('');
    const [multiplicador, setMultiplicador] = useState('');
    const [fixo, setFixo] = useState('');
    const [carregaPost, setCarregaPost] = useState(false);

    useEffect(() => {
        const carregar = async () => {
            try {
                const response = await http.get('/bancas/opcoes');
                const opcoes = response.data.data.opcoes || {};

                // Banca antiga pode ter só a flag ligada, sem o tipo gravado
                setTipo(opcoes.tipo_milhar_brinde ?? (opcoes.milhar_brinde ? 'multiplicado' : 'nao'));
                setMinimo(opcoes.minimo_milhar_brinde ?? '');
                setMaximo(opcoes.maximo_milhar_brinde ?? '');
                setMultiplicador(opcoes.multiplicador_milhar_brinde ?? '');
                setFixo(opcoes.fixo_milhar_brinde ?? '');
            } catch (e) {
                alerta(e.response?.data || { message: 'Erro ao carregar as configurações.' });
            }
        };

        carregar();
    }, []);

    const mandaAlteracoes = async () => {
        try {
            setCarregaPost(true);

            // Mesmo payload que a aba Dados mandava para estas chaves
            const formData = new FormData();
            formData.append('milhar_brinde', tipo === 'nao' ? false : true);
            formData.append('tipo_milhar_brinde', tipo);
            formData.append('minimo_milhar_brinde', minimo);
            formData.append('maximo_milhar_brinde', maximo);
            formData.append('fixo_milhar_brinde', fixo);
            formData.append('multiplicador_milhar_brinde', multiplicador);

            const res = await http.post('/bancas/opcoes', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            // O perfil guardado no navegador carrega a milhar brinde; atualiza
            // como a aba Dados faz ao salvar
            const perfil = await http.get('/perfil');
            localStorage.setItem('usuario', JSON.stringify(perfil.data.data.usuario));

            alerta(res.data);
        } catch (error) {
            alerta(error.response?.data || { message: 'Erro ao salvar.' });
        } finally {
            setCarregaPost(false);
        }
    };

    return (
        <div className={styles.conteudoPrincipal}>
            <div className={styles.formGroup}>
                <div className={styles.label}>
                    <label>Milhar Brinde disponível:</label>
                </div>
                <div className={styles.input}>
                    <select
                        style={{ width: 200 }}
                        className="form-control"
                        name="milharBrinde"
                        id="milharbrinde"
                        value={tipo}
                        onChange={(e) => setTipo(e.target.value)}
                    >
                        {TIPOS.map(({ valor, rotulo }) => (
                            <option key={valor} value={valor}>{rotulo}</option>
                        ))}
                    </select>
                </div>
            </div>

            {tipo !== 'nao' && (
                <CampoNumero rotulo="Valor mínimo para ativar milhar brinde:" valor={minimo} aoMudar={setMinimo} />
            )}
            {tipo === 'multiplicado' && (
                <>
                    <CampoNumero rotulo="Valor máximo para multiplicar milhar brinde:" valor={maximo} aoMudar={setMaximo} />
                    <CampoNumero rotulo="Multiplicador da milhar brinde:" valor={multiplicador} aoMudar={setMultiplicador} />
                </>
            )}
            {tipo === 'fixo' && (
                <CampoNumero rotulo="Prêmio fixo da milhar brinde:" valor={fixo} aoMudar={setFixo} />
            )}

            <div className={styles.buttonStyle}>
                <button
                    className='btn btn-success'
                    onClick={mandaAlteracoes}
                    disabled={carregaPost}
                >
                    Salvar
                </button>
            </div>
        </div>
    );
}
